import React from "react";
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {Box,Toolbar,List,Typography,Divider,IconButton,Drawer as MuiDrawer} from '@mui/material';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';

import {ChevronLeft as ChevronLeftIcon,ChevronRight as ChevronRightIcon, Menu as MenuIcon} from "@mui/icons-material";

import { useSelector, useDispatch } from "react-redux";

import AppSwitcher from "../components/AppSwitcher";
import ProfileMenu from "../components/ProfileMenu";
import AppSideMenu from "../components/AppSideMenu";
import { USER_TYPE } from "../const";


const drawerWidth = 180;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,

}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),  
  }),
);

export default function MiniDrawer() {
  const theme = useTheme();
  let dispatch = useDispatch();
  
  const isLogin = useSelector((state: any) => state.isLogin);
  const UserType = useSelector((state:any)=> state.user?state.user.type:null);
  const org = useSelector((state:any)=> state.user?state.user.org:null);
  const currentApp = useSelector((state:any)=>state.currentApp.name);

  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <>
      {isLogin?
      <>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="fixed" open={open}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                ...(open && { display: 'none' }),
              }}
            >
              <MenuIcon/>
            </IconButton>

            <Typography variant="h6">
              <div className="logo">{currentApp} {UserType === USER_TYPE.CUSTOMER && <>&nbsp; | &nbsp; {org}</> }</div> 
              
            </Typography>

            <AppSwitcher/>
            <ProfileMenu/>
            
          </Toolbar> 
        </AppBar>

        <Drawer variant="permanent" open={open}>
          <DrawerHeader sx={{minHeight:'20px!important'}}>
            <IconButton onClick={handleDrawerClose} color="primary">
              {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </DrawerHeader>
          <Divider />
          <List>
              <AppSideMenu onClick={handleDrawerClose}/>
          </List>
          <Divider />
      </Drawer>
      </Box>
      </>
      :''} 
    </>
  );
}
 